export default "__VITE_ASSET__D$QBtgXP__"